import * as tslib_1 from "tslib";
var MergedRouterStateSerializer = /** @class */ (function () {
    function MergedRouterStateSerializer() {
    }
    MergedRouterStateSerializer.prototype.serialize = function (routerState) {
        return {
            url: routerState.url,
            params: mergeRouteParams(routerState.root, function (r) { return r.params; }),
            queryParams: mergeRouteParams(routerState.root, function (r) { return r.queryParams; }),
            data: mergeRouteData(routerState.root)
        };
    };
    return MergedRouterStateSerializer;
}());
export { MergedRouterStateSerializer };
function mergeRouteParams(route, getter) {
    if (!route) {
        return {};
    }
    var currentParams = getter(route);
    var primaryChild = route.children.find(function (c) { return c.outlet === 'primary'; }) || route.firstChild;
    return tslib_1.__assign({}, currentParams, mergeRouteParams(primaryChild, getter));
}
function mergeRouteData(route) {
    if (!route) {
        return {};
    }
    var currentData = route.data;
    var primaryChild = route.children.find(function (c) { return c.outlet === 'primary'; }) || route.firstChild;
    return tslib_1.__assign({}, currentData, mergeRouteData(primaryChild));
}
